import type { SupportedStripeElementType } from '../CreditCardInput/StripeInput';
import type { CreditCardCvcProps } from './CreditCardCvc';
import { CreditCardCvc } from './CreditCardCvc';
import type { CreditCardExpiryProps } from './CreditCardExpiry';
import { CreditCardExpiry } from './CreditCardExpiry';
import type { CreditCardNumberProps } from './CreditCardNumber';
import { CreditCardNumber } from './CreditCardNumber';

export type CreditCardInputProps<TType extends SupportedStripeElementType> = {
  type: TType;
} & (TType extends 'cardNumber'
  ? CreditCardNumberProps
  : TType extends 'cardCvc'
    ? CreditCardCvcProps
    : CreditCardExpiryProps);

/**
 * Render a Stripe Credit Card input field.
 *
 * @remarks
 * Must be a child of {@link StripeProvider} and {@link StripeElementsProvider}.
 * @see https://corgi-x.tfd.engineering/components/creditcardinput
 */
export function CreditCardInput<TType extends SupportedStripeElementType>(
  props: CreditCardInputProps<TType>
) {
  const { type, ...restProps } = props;
  switch (type) {
    case 'cardNumber':
      return <CreditCardNumber {...(restProps as CreditCardNumberProps)} />;
    case 'cardCvc':
      return <CreditCardCvc {...(restProps as CreditCardCvcProps)} />;
    case 'cardExpiry':
      return <CreditCardExpiry {...(restProps as CreditCardExpiryProps)} />;
  }
  return <></>;
}
